import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class PackRecord extends RecordBase {
  static defaultAttributes = {
    name: '',
    description: '',
    packs: [],
    specialties: [],
    pack_packages: [],
    created_at: '',
    updated_at: '',
  };

  static _attributeNames = null;

  static get attributeNames() {
    const { t } = useTranslation();
    const trAttr = (attr) => t(`packs.attributes.${attr}`);
    if (!this._attributeNames) {
      this._attributeNames = {
        name: trAttr('name'),
        packages: trAttr('packages'),
        specialties: trAttr('specialties'),
        description: trAttr('description'),
        created_at: trAttr('created_at'),
        updated_at: trAttr('updated_at'),
      };
    }
    return this._attributeNames;
  }

  toParams(attrs = {}) {
    const {
      name,
      description,
      packs,
      specialties,
      created_at,
      updated_at,
    } = this.toObject();

    let packsIds = [];
    if (packs) {
      packsIds = packs.map((item) => item.id);
    }

    let specialtiesIds = [];
    if (specialties) {
      specialtiesIds = specialties.map((item) => item.id);
    }

    return {
      data: {
        attributes: {
          name,
          description,
          packs: packsIds,
          specialties: specialtiesIds,
          created_at,
          updated_at,
          ...attrs,
        },
      },
    };
  }
}
